import React, { FC, useState } from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Layout from "../Common/NewLayout";
import Header from "../Common/NewLayout/Header";
import CompanyType from "./CompanyType/CompanyType";
import { CustomButton } from "../Ui/CustomButton";
import { companyType } from "../../enums/company";
import { useToastNotifications } from "../../utils/toastUtils";
import { isAuthenticated } from "../../services/LocalStorage";
import { OnboardingInfo } from "../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { ONBOARDING } from "../../graphql/onboarding/onboarding/query";
import { useQuery } from "@apollo/client";
import {
  CheckPaymentStripe,
  CheckPaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CheckPaymentStripe";
import { CHECK_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/query";
import { Payment_Status } from "../../enums/stripe";

const ChoiceProvider: FC = () => {
  const navigate = useNavigate();
  const [choice, setChoice] = useState<string>(companyType.EXISTING);
  const { showErrorToast } = useToastNotifications();

  const { loading } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      const { company, offer } = data?.onboardingInfo || {};
      if (company && offer) {
        const { existingCompany } = company;
        setChoice(existingCompany ? companyType.EXISTING : companyType.CREATE);
      }
    },
  });

  const { loading: checkStripeLoading } = useQuery<
    CheckPaymentStripe,
    CheckPaymentStripeVariables
  >(CHECK_PAYMENT_STRIPE, {
    variables: { changeStep: false },
    onCompleted: ({ checkPaymentStripe }) => {
      if (checkPaymentStripe === Payment_Status.PAID) {
        navigate("/company");
      }
    },
  });

  const handleNext = () => {
    if (!choice) {
      showErrorToast({
        description: "Veuillez sélectionner le type d’entreprise.",
      });
      return;
    }
    if (choice === companyType.CREATE) {
      navigate("/package");
    } else if (choice === companyType.EXISTING) {
      navigate("/offer");
    }
  };

  if (!isAuthenticated()) {
    window.location.href = "/";
  }

  if (checkStripeLoading) {
    return (
      <Box position="absolute" top="50%" left="50%">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Layout
      title="Entreprise"
      description="Choisir le type de votre société."
      isDoubleContent
      loading={loading}
    >
      <Header
        title="Type d’entreprise"
        description="Choisissez le type de votre entreprise."
      />
      <CompanyType choise={choice} handleValue={setChoice} />
      <Box display="flex" alignItems="center" justifyContent="center">
        <CustomButton
          type="button"
          variant="primary"
          onClick={handleNext}
          label="button.next"
        />
      </Box>
    </Layout>
  );
};

export default ChoiceProvider;
